import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function DuoPick({ v }) {
  if (!v.showDuoPick) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "97", "padding": "20px" }} onClick={v.closeDialog}>
        <div className="gp-venster" onClick={v.stopProp} style={{ "width": "min(440px,100%)", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "14px" }}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "10px" }}>
            <div style={{ "fontSize": "19px", "fontWeight": "700", "flex": "1 1 auto" }}>
              Samen krabbelen
            </div>
            <button onClick={v.closeDialog} title="Sluiten" style={css(v.sluitStyle)}>
              <Kruis maat={20} />
            </button>
          </div>
          <div style={{ "display": "flex", "flexDirection": "column", "gap": "9px", "maxHeight": "340px", "overflowY": "auto", "padding": "3px 5px 5px 1px", "margin": "-3px -5px -5px -1px" }}>
            {toList(v.duoCandidates).map((c, $index) => (
              <React.Fragment key={$index}>
                <button onClick={c?.onPick} className="gp-swatch" style={{ "display": "flex", "alignItems": "center", "gap": "9px", "padding": "8px 10px", "border": "3px solid var(--ink)", "borderRadius": "12px", "background": "#fff", "cursor": "pointer", "font": "inherit", "color": "var(--ink)", "textAlign": "left", "width": "100%", "boxSizing": "border-box" }}>
                  <img alt="" src={c?.avatarUrl} style={{ "width": "32px", "height": "32px", "imageRendering": "pixelated", "border": "3px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
                  <span style={{ "fontSize": "14px", "fontWeight": "600", "flex": "1 1 auto", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                    <Interp v={c?.name} />
                  </span>
                  <span style={css(c?.dotStyle)} />
                </button>
              </React.Fragment>
            ))}
          </div>
          {v.hasDuoError ? (<>
            <div style={{ "fontSize": "13px", "color": "var(--fout)", "fontWeight": "600" }}>
              <Interp v={v.duoError} />
            </div>
          </>) : null}
        </div>
      </div>
      {' '}
    </>
  );
}
